import { DatePipe, NgTemplateOutlet } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { StringBooleanMap } from '@bn/shared/entities/models';
import { BadgeComponent } from '@bn/web-ui/badge/badge.component';
import { ButtonComponent } from '@bn/web-ui/button';
import { DropdownMenuItem } from '@bn/web-ui/dropdown-menu';
import { DropdownMenuComponent } from '@bn/web-ui/dropdown-menu/dropdown-menu.component';
import { FlagComponent } from '@bn/web-ui/flag';
import { NotAvailableComponent } from '@bn/web-ui/not-available';
import { TableSkeletonTemplateComponent } from '@bn/web-ui/standalone';
import { eventLogActionColor, eventLogFeatureIcon, eventLogMethodColor, EventRowLogContext } from '../../../../models';
import { EventRow } from '../../../../openapi';
import { WafService } from '../../../../services/waf.service';
import { EventLogsRowDetailComponent } from '../event-logs-row-detail/event-logs-row-detail.component';

@Component({
  selector: 'app-app-shield-event-logs-table',
  templateUrl: './event-logs-table.component.html',
  styleUrls: ['./event-logs-table.component.scss'],
  imports: [
    BadgeComponent,
    ButtonComponent,
    DatePipe,
    DropdownMenuComponent,
    EventLogsRowDetailComponent,
    FaIconComponent,
    FlagComponent,
    NgTemplateOutlet,
    NotAvailableComponent,
    TableSkeletonTemplateComponent,
    TooltipModule,
  ],
})
export class EventLogsTableComponent {
  readonly rows = input<EventRow[]>([]);
  readonly isLoading = input(false);
  readonly compact = input(false);

  readonly actionColor = eventLogActionColor;
  readonly featureIcon = eventLogFeatureIcon;
  readonly methodColor = eventLogMethodColor;

  readonly #wafService = inject(WafService);

  openRows: StringBooleanMap = {};

  onRowToggle(logId: string): void {
    this.openRows[logId] = !this.openRows[logId];
  }

  fieldsOf(row: EventRow): Record<string, string> {
    return row.fields ?? {};
  }

  logOf(row: EventRow): EventRowLogContext {
    return (row.log ?? {}) as EventRowLogContext;
  }

  messageOf(row: EventRow): string {
    return this.logOf(row).Message ?? '';
  }

  ruleMenuItems(ruleId: string): DropdownMenuItem[] {
    return this.#wafService.isRuleBlocking(ruleId)
      ? [
          { label: 'Disable rule', action: 'disable', id: ruleId },
          { label: 'Make rule log only', action: 'log', id: ruleId },
        ]
      : [
          { label: 'Enable rule', action: 'enable', id: ruleId },
          { label: 'Disable rule', action: 'disable', id: ruleId },
        ];
  }

  onRuleAction({ action, id }: DropdownMenuItem): void {
    const ruleId = String(id);

    if (action === 'disable') this.#wafService.disableRules([ruleId]);
    else if (action === 'enable') this.#wafService.enableRules([ruleId]);
    else if (action === 'log') this.#wafService.logRules([ruleId]);
  }
}
